import request from '@/utils/request';

// 获取获取应用分类列表
export function appList(options) {
  return request({
    url: '/op/appReferencce/list',
    method: 'get',
    params: options
  });
}
// 移位应用类型
export function moveApp(data) {
  return request({
    url: '/op/appReferencce/moveAppType',
    method: 'post',
    data: data
  });
}
// 新增应用分类
export function addAppType(data) {
  return request({
    url: '/op/appReferencce/addAppType',
    method: 'post',
    data: data
  });
}
// 编辑应用分类
export function updateAppType(data, id) {
  return request({
    url: '/op/appReferencce/updateAppType/' + id,
    method: 'post',
    data: data
  });
}
// 删除应用分类
export function dateleAppType(data, id) {
  return request({
    url: '/op/appReferencce/deleteAppType/' + id,
    method: 'DELETE',
    data: data
  });
}
